<template>
  <div id="page-user-edit">

    <vx-card >
      <div slot="no-body" class="tabs-container px-6 pt-6">
        <vs-tabs  class="tab-action-btn-fill-conatiner">
          <vs-tab label="Account" icon-pack="feather" icon="icon-user">
            <div class="tab-text">
              <user-add-tab-account class="mt-4"  />
            </div>
          </vs-tab>
        </vs-tabs>
      </div>
    </vx-card>

  </div>
</template>

<script>

import UserAddTabAccount from "./UserAddTabAccount.vue"
import moduleUserManagement from '@/store/user-management/moduleUserManagement.js'

export default {
  components: {
    UserAddTabAccount,
  },
  data() {
    return {
      user_data: null,
      user_logbok_class: [],
      user_not_found: false,
      activeTab: 0,
    }
  },
  watch: {

  },
  methods: {
    
  },
  created() {
    // Register Module UserManagement Module
    if(!moduleUserManagement.isRegistered) {
      this.$store.registerModule('userManagement', moduleUserManagement)
      moduleUserManagement.isRegistered = true
    }
  }
}

</script>
